"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = exports.wrapHTML = exports.nothing = exports.fromJSX = void 0;
var React = __importStar(require("react"));
/** Creates a widget from a cont -> JSX.Element */
var fromJSX = function (w) { return ({
    run: w,
    wrapHTML: function (f) { return (0, exports.wrapHTML)(f)(this); },
    map: function (f) { return (0, exports.map)(f)(this); },
    never: function () { return never(this); }
}); };
exports.fromJSX = fromJSX;
var nothing = function () { return (0, exports.fromJSX)(function (_) { return React.createElement(React.Fragment, null); }); };
exports.nothing = nothing;
var never = function (inner_widget) { return (0, exports.fromJSX)(function (_) { return inner_widget.run(function (_) { }); }); };
var wrapHTML = function (wrap) {
    return function (widget_a) { return (0, exports.fromJSX)(function (on_done) { return wrap(widget_a.run(function (res_a) { return on_done(res_a); })); }); };
};
exports.wrapHTML = wrapHTML;
var map = function (f) { return function (widget_a) { return (0, exports.fromJSX)(function (on_done_b) { return widget_a.run(function (res_a) { return on_done_b(f(res_a)); }); }); }; };
exports.map = map;
